import WidgetComponent, { IWidgetLayout } from "../../../components/widgets-layout/widget-component/widget-component";
import { IWidgetModal, Widget } from "../../../components/widgets-layout/widget-utils";
import { IWidgetLayoutConfig } from "../../../components/widgets-layout/widgets-layout";

interface IScreenConfigurationConfig {
  layout: IWidgetLayout;
  selectedEvent: string;
  handleDataChange(data: IScreenConfigurationData): void;
}

export interface IScreenConfigurationData {
  layout: IWidgetLayoutConfig[];
  layoutItems: Widget[];
}

const ScreenConfiguration = ({layout, selectedEvent, handleDataChange}: IScreenConfigurationConfig) => {
  const handleLayoutChange = (layout: IWidgetLayout) => {
    handleDataChange(layout);
  };

  const widgets: IWidgetModal[] = [{
    type: "text"
  },
  {
    type: "reference",
    datamodelId: selectedEvent,
    datamodelType: "event",
  }, 
  {
    type: "datamodelField",
    datamodelId: selectedEvent,
    datamodelType: "event",
  }];

  return <div className="screenConfiguration">
    <WidgetComponent 
      handleLayoutChange={handleLayoutChange}
      widgets={widgets}
      layout={layout} />
  </div>;
};

export default ScreenConfiguration;